export default __webpack_public_path__ + "static/media/PMON-BUSD.5ec02d06.svg";